import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DynamicReviewsFormGroup, ExcludedProductItem } from '../../model';
import {
  DynamicReviewsExtension,
  ICheckoutExtensions,
  ProductReviews,
} from '@pdqdev/pdq-shared/dist/interfaces/ICheckoutExtensions';
import { DynamicRule, RuleEntity } from '@pdqdev/pdq-shared/dist/entities/Rules';

@Component({
  selector: 'dynamic-reviews-form-settings',
  templateUrl: './dynamic-reviews-form-settings.component.html',
  styleUrls: ['./dynamic-reviews-form-settings.component.scss'],
  standalone: false,
})
export class DynamicReviewsFormSettingsComponent {
  @Input() formGroup: FormGroup<DynamicReviewsFormGroup>;
  @Input() loadedExtension: ICheckoutExtensions;
  @Input() excludeProductsRules: DynamicRule[] = [];
  @Input() excludeProductsEntities: RuleEntity[] = [];

  @Output() addExcludedProducts = new EventEmitter<void>();
  @Output() removeExcludedProduct = new EventEmitter<string | number>();

  LayoutStyle = DynamicReviewsExtension.LayoutStyle;
  ReviewDataSource = DynamicReviewsExtension.ReviewDataSource;
  readonly minStarRatingStep = DynamicReviewsExtension.MIN_STAR_RATING_STEP;
  readonly minStarRatingMin = DynamicReviewsExtension.MIN_STAR_RATING_STEP;
  readonly minStarRatingMax = DynamicReviewsExtension.CSV_MAX_STAR_RATING;
  isReviewRulesCollapsed = false;

  readonly ExclusionMode = ProductReviews.ExclusionMode;
  readonly exclusionModeOptions = [
    { value: ProductReviews.ExclusionMode.MANUAL, label: 'Manual' },
    { value: ProductReviews.ExclusionMode.SMART, label: 'Smart' },
  ];

  get isCsvSelected(): boolean {
    return this.formGroup.controls.importMethod.value === 'csv';
  }

  get isManualExclusion(): boolean {
    return this.formGroup.controls.excludeProductsMode.value !== ProductReviews.ExclusionMode.SMART;
  }

  get excludedProducts(): ExcludedProductItem[] {
    return this.formGroup.controls.excludeProducts.value ?? [];
  }

  setExclusionMode(mode: string): void {
    this.formGroup.controls.excludeProductsMode.setValue(mode as ProductReviews.ExclusionMode);
    this.formGroup.markAsDirty();
  }
}
